/**
 * Scroll offset from top
 *
 * @package booom-wiki
 */


document.addEventListener("DOMContentLoaded", function() {

  document.documentElement.setAttribute("data-treshold", 'false');

  window.addEventListener("scroll",() => {
    displayOffset();
  }, {passive: true} );

});

const headerHeight = document.querySelector('.entry-content > .wp-block-cover').getBoundingClientRect().height;
const elemYOffset = headerHeight;


function displayOffset(){

  const pageYOffset = window.pageYOffset;

  if ( pageYOffset >= elemYOffset ) {
    document.documentElement.setAttribute("data-treshold", 'true');
  } else {
    document.documentElement.setAttribute("data-treshold", 'false');
  }

};
